import { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { Link } from "react-router-dom"
import { fetchSolicitudes, fetchEntity } from '../actions'
import { getSolicitudes, getEntity } from '../reducers'
import Layout from '../layout'
import {
    Flex,
    Box,
    useColorModeValue,
    Text,
    Button,
    IconButton,
    Input,
} from '@chakra-ui/react'
import DataTable from 'react-data-table-component'
import { DownloadIcon, RepeatIcon } from '@chakra-ui/icons'
import { CSVLink } from "react-csv"

const columns = [
    { name: 'Fecha', selector: row => row.fechaCreacion, sortable: true },
    { name: 'Nombre', selector: row => row.nombre, sortable: true },
    { name: 'Estado', selector: row => row.estado, sortable: true },
    { name: 'Etapa', selector: row => row.etapa, sortable: true },
    { name: 'Opciones', selector: row => row.opcion, sortable: false },
];

const RequestList = () => {

    const dispatch = useDispatch()
    const color = useColorModeValue('white', 'gray.800')
    const solicitudes = useSelector(state => getSolicitudes(state))
    const financiamiento_estados = useSelector(state => getEntity(state, 'financiamiento'))

    useEffect(() => {
        dispatch(fetchSolicitudes())
        dispatch(fetchEntity('financiamiento'))
    }, [])

    const [filterText, setFilterText] = useState('')
    const [filterDateStart, setFilterDateStart] = useState('')
    const [filterDateFinish, setFilterDateFinish] = useState('')


    const filteredItems = solicitudes.filter(item => {
        let flag = true
        if (filterText !== '') {
            flag = `${item.cNombres} ${item.cNombres2 || ''} ${item.cApellidoPaterno} ${item.cApellidoMaterno || ''}`.toLowerCase().includes(filterText.toLowerCase())
        }
        if( filterDateStart !== '' && filterDateFinish !== ''){
            flag = item.dFechaCreacion >= filterDateStart && item.dFechaCreacion <= filterDateFinish 
        }
        return flag
    })

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            setFilterText('')
            setFilterDateStart('')
            setFilterDateFinish('')
        }
        return <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '3px' }}>

            De
            <Input type="date" onChange={e => setFilterDateStart(e.target.value)} value={filterDateStart} />
            Hasta
            <Input type="date" onChange={e => setFilterDateFinish(e.target.value)} value={filterDateFinish} />
            <Input placeholder="Busqueda por nombre" onChange={e => setFilterText(e.target.value)} value={filterText} />
            <IconButton aria-label='Clean' icon={<RepeatIcon />} onClick={handleClear} />
            <CSVLink
                filename={"Solicitudes.csv"}
                headers={[
                    { label: "id", key: "id" },
                    { label: "Fecha", key: "fechaCreacion" },
                    { label: "Nombre", key: "nombre" },
                    { label: "Estado", key: "estado" },
                    { label: "Etapa", key: "etapa" }
                ]}
                data={filteredItems.map(solicitud => {
                    return {
                        id: solicitud.id,
                        fechaCreacion: new Date(solicitud.dFechaCreacion).toISOString().split('T')[0],
                        nombre: `${solicitud.cNombres} ${solicitud.cNombres2 || ''} ${solicitud.cApellidoPaterno} ${solicitud.cApellidoMaterno || ''}`,
                        estado: financiamiento_estados.reduce((text, estado) => {
                            if (estado.id === solicitud.cEstadoFinanciamiento) return estado.nombre
                            return text
                        }, 'En espera de análisis'),
                        etapa: solicitud.cEtapa || 'En Proceso'
                    }
                })}
            >
                <IconButton aria-label='download' icon={<DownloadIcon />} />
            </CSVLink>
        </div>

    }, [filterText, filterDateStart, filterDateFinish])


    return (
        <Layout>
            <Flex flexDirection={"column"} alignItems={"center"} w={'100%'} >
                <Box
                    bg={color}
                    rounded={'md'}
                    m={3}
                    p={6}
                    w={"full"}
                >
                    <Text fontSize={"lg"} >Solicitudes envíadas</Text>
                    <br />

                    <DataTable
                        pagination
                        columns={columns}
                        defaultSortAsc={false}
                        defaultSortFieldId={1}
                        subHeader
                        persistTableHead
                        subHeaderComponent={subHeaderComponentMemo}
                        data={filteredItems.map(solicitud => {
                            return {
                                id: solicitud.id,
                                fechaCreacion: new Date(solicitud.dFechaCreacion).toISOString().split('T')[0],
                                nombre: `${solicitud.cNombres} ${solicitud.cNombres2 || ''} ${solicitud.cApellidoPaterno} ${solicitud.cApellidoMaterno || ''}`,
                                estado: financiamiento_estados.reduce((text, estado) => {
                                    if (estado.id === solicitud.cEstadoFinanciamiento) return estado.nombre
                                    return text
                                }, 'En espera de análisis'),
                                etapa: solicitud.cEtapa || 'En Proceso',
                                opcion: <Link to={`solicitud/${solicitud.id}/view`}><Button colorScheme="teal" variant="outline">Detalle</Button></Link>
                            }
                        })}
                    />
                </Box>
            </Flex>
        </Layout>
    )
}

export default RequestList